// extracted by css-extract-rspack-plugin
export default {"cls1":"CoauthorConfirmationCard-cls1_eGy","cls2":"CoauthorConfirmationCard-cls2_bzz CoauthorConfirmationCard-cls1_eGy"};